import { render } from "./_WithLabel.vue?vue&type=template&id=184e6011"
import script from "./_WithLabel.vue?vue&type=script&lang=js"
export * from "./_WithLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/FormElements/_WithLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "184e6011"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('184e6011', __exports__)) {
    api.reload('184e6011', __exports__)
  }
  
  module.hot.accept("./_WithLabel.vue?vue&type=template&id=184e6011", () => {
    api.rerender('184e6011', render)
  })

}


export default __exports__